<div class="d-flex justify-content-between align-items-center flex-column h-100 text-center">
	<h4 class="mb-4">Czy chcesz zakończyć zadanie?</h4>
	<div>
		<button mat-raised-button [mat-dialog-close]="true" class="me-3" color="primary">Tak</button>
		<button mat-raised-button [mat-dialog-close]="false" color="warn">Nie</button>
	</div>
</div>
